import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'generic-table-multi-collumns',
  templateUrl: './generic-table-multi-collumns.component.html',
  styleUrl: './generic-table-multi-collumns.component.scss',
  standalone: false,
})
export class GenericTableMultiCollumnsComponent implements OnInit {
  @Input() table!: any;

  jsonData: any[] = [];
  columnsName: string[] = [];
  columns: string[] = [];

  ngOnInit() {
    this.createCollumns();
  }

  createCollumns() {
    this.jsonData = this.table.attributes;

    if (this.jsonData.length > 0) {
      this.columnsName = Object.keys(this.jsonData[0]).map(column => this.jsonData[0][column].key);
      this.columns = Object.keys(this.jsonData[0]);
    }
  }
}
